import { pathOr } from "ramda";
import { resourceFilterConditionExecutor } from "src/components/displayerConditionFn";
import { conditionalFuncs } from "src/utilities/conditionalFn";
import { isNotEmpty } from "src/utilities/hasValue";

interface IResourceFinder {
    getResource: (resourceFinder: any, apiResource: any, apiResourceName: any) => any;
}



interface ResourceFinderOption {
    "apply_rule": string;
    "filter_option": {
        "apply_logical": string;
        "conditions": {
            "satisfies": string;
            "arguments": any[]
        }[];
    }
}




export class ResourceFinder implements IResourceFinder {

    getResource(resourceFinder: ResourceFinderOption, loanAppSpec: any, apiResourceName: any) {
        return this.getFilteredResource(
            resourceFinder,
            loanAppSpec,
            apiResourceName
        );
    }

    private getFilteredResource = (
        resourceFinder: any,
        loanAppSpec: any,
        apiResourceName: any
    ) => {
        const resources = pathOr({}, [apiResourceName], loanAppSpec);

        if (isNotEmpty(resourceFinder)) {
            const args = resourceFilterConditionExecutor(resourceFinder, resources);
            const applyRule = pathOr('', ['apply_rule'], resourceFinder)
            const result = conditionalFuncs(applyRule)(args);
            return result;
        } else {
            return resources;
        }
    };
}


